import { IEnvironment } from './interfaces/environment.interface';

export const environment: IEnvironment = {
  ASSETS_PATH: '/static/assets',
  ASSETS_IMAGES: '/static/assets/images',
  CONFIG_ROOT: 'static/assets/config/data.json?new=true',
  production: true,

  APP_LANDING_API_HOST: 'https://landing-api.noda.live/api',
};
